import { render, staticRenderFns } from "./PkgStdSubItemTxt.vue?vue&type=template&id=5b2217e4&"
import script from "./PkgStdSubItemTxt.vue?vue&type=script&lang=js&"
export * from "./PkgStdSubItemTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports